export default "__VITE_ASSET__b5a19500__"